import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { combineLatest, filter, map, Observable, pipe } from 'rxjs';

import { MultiUserPreferences } from 'app/features/settings/models';
import { activityNumbersToActivities } from 'app/shared/features/activity-selector/utils';
import { selectActivityListIfLoaded } from 'app/state/activities/activity.selectors';

import { multiUserPreferencesFeatureKey, MultiUserPreferencesState } from './multi-user-preferences.reducer';

export const selectPreferencesState = createFeatureSelector<MultiUserPreferencesState>(
    multiUserPreferencesFeatureKey,
);

export const selectMultiUserPreferences = createSelector(
    selectPreferencesState,
    (state) => state.multiUserPreferences,
);

export const selectMultiUserPreferencesIfLoaded = pipe(
    select(selectMultiUserPreferences),
    filter((preferences): preferences is MultiUserPreferences => !!preferences),
);

export const selectMultiUserRecentActivitiesIfLoaded = pipe(
    selectMultiUserPreferencesIfLoaded,
    map((preferences) => preferences?.recentActivityNumbers ?? []),
);

export const selectMultiuserUserRecentActivities = (store: Observable<object>) =>
    combineLatest([
        store.pipe(selectMultiUserRecentActivitiesIfLoaded),
        store.pipe(selectActivityListIfLoaded),
    ]).pipe(
        map(([recentActivityNumbers, activities]) =>
            activityNumbersToActivities({ activityNumbers: recentActivityNumbers, activities }),
        ),
    );

export const selectLastMultiUserRecentActivityNumberIfLoaded = createSelector(
    selectPreferencesState,
    (state) => state.multiUserPreferences?.recentActivityNumbers[0] ?? undefined,
);

export const selectMultiUserRecentEmployeeNumbersIfLoaded = pipe(
    selectMultiUserPreferencesIfLoaded,
    map((preferences) => preferences.recentEmployeeNumbers ?? []),
);

export const selectMultiUserRecentProductBoxNumberIfLoaded = pipe(
    selectMultiUserPreferencesIfLoaded,
    map((preferences) => preferences.recentProductBoxNumber ?? -1),
);
